import api from "api/api";

export const getExternalTrainingByUserIdQuery = async ({ id, userScope }) =>
  await api.get(`/datatrack/external_training/user/${id}?scope=${userScope}`);

export const uploadExternalTrainingByuserIdQuery = async ({
  data,
  setProgression,
  userScope,
}) =>
  await api.postFile(
    `/datatrack/external_training/from-excel?scope=${userScope}`,
    data,
    {
      onUploadProgress: (event) => {
        if (event.total) {
          const percentComplete = (event.loaded / event.total) * 100;
          setProgression(percentComplete.toFixed());
        }
      },
    }
  );
